export const ProductCatalogUIContext = {
    isStandaloneUI: true
}
